// BlogHome.js
import React, { useEffect, useState } from 'react';
import { firestore, collection, getDocs } from './firebase-config';
import { Link } from 'react-router-dom';
import './Blog.css';

const BlogHome = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const snapshot = await getDocs(collection(firestore, 'blogPosts'));
      const data = snapshot.docs.map(doc => doc.data());
      setPosts(data);
    };
    fetchPosts();
  }, []);

  return (
    <div className="blog-home">
      {/* <h1>Blog</h1> */}
      {posts.length === 0 ? (
        <p></p>
      ) : (
        posts.map(post => (
          <div key={post.slug} className="blog-preview">
            <h2>
              <Link to={`/blog/${post.slug}`}>{post.title}</Link>
            </h2>
            <p>
              {new Date(post.publishedAt?.seconds * 1000).toLocaleDateString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
};

export default BlogHome;
